import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import { useState } from "react";
import { getAffiliateUrl } from "@/constants/affiliate";

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  return (
    <header className="w-full py-4 px-4 md:px-8 bg-background/95 backdrop-blur-sm sticky top-0 z-50 shadow-sm border-b border-border">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <span className="text-xl md:text-2xl font-bold text-primary">Crystal Hydration Guide</span>
        </Link>
        
        {/* Mobile menu button */}
        <Button 
          variant="ghost" 
          size="icon"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="md:hidden"
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={isMenuOpen}
        >
          <Menu aria-hidden="true" />
        </Button>
        
        {/* Desktop navigation */}
        <div className="hidden md:flex items-center gap-4">
          <nav className="flex items-center gap-6 mr-4">
            <Link to="/" className="text-foreground/80 hover:text-primary transition font-medium">Home</Link>
            <Link to="/slimcrystal" className="text-foreground/80 hover:text-primary transition font-medium">Review</Link>
            <Link to="/blog" className="text-foreground/80 hover:text-primary transition font-medium">Blog</Link>
            <Link to="/faq" className="text-foreground/80 hover:text-primary transition font-medium">FAQ</Link>
            <Link to="/about" className="text-foreground/80 hover:text-primary transition font-medium">About</Link>
          </nav>
          <a href={getAffiliateUrl("nav-desktop")} rel="sponsored nofollow noopener" target="_blank">
            <Button id="cta-nav-desktop" className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold">
              Get Your SlimCrystal Bottle
            </Button>
          </a>
        </div>
        
        {/* Mobile navigation */}
        {isMenuOpen && (
          <div className="absolute top-full left-0 right-0 bg-background shadow-lg border-b border-border py-4 px-6 md:hidden flex flex-col gap-4">
            <Link to="/" className="text-foreground/80 hover:text-primary transition py-2 font-medium">Home</Link>
            <Link to="/slimcrystal" className="text-foreground/80 hover:text-primary transition py-2 font-medium">Review</Link>
            <Link to="/blog" className="text-foreground/80 hover:text-primary transition py-2 font-medium">Blog</Link>
            <Link to="/faq" className="text-foreground/80 hover:text-primary transition py-2 font-medium">FAQ</Link>
            <Link to="/about" className="text-foreground/80 hover:text-primary transition py-2 font-medium">About</Link>
            <a href={getAffiliateUrl("nav-mobile")} rel="sponsored nofollow noopener" target="_blank">
              <Button id="cta-nav-mobile" className="bg-primary hover:bg-primary/90 text-primary-foreground mt-2 w-full font-semibold">
                Get Your SlimCrystal Bottle
              </Button>
            </a>
          </div>
        )}
      </div>
    </header>
  );
};

export default NavBar;
